// src/components/canine-teeth/ToolCanineTeeth.js

import React, { useEffect, useState } from 'react';
import ImageUpload from './ImageUpload';
import Topbar from '../Topbar';
import { auth, db } from '../../firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import '../tools.css';
import { Circles } from 'react-loader-spinner';

const ToolCanineTeeth = () => {
  const [user, setUser] = useState(null);
  const [userInfo, setUserInfo] = useState(null);
  const [isAuthLoading, setIsAuthLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        setUser(user);
        const docRef = doc(db, 'users', user.uid);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setUserInfo(docSnap.data());
        } else {
          console.warn('Nessun documento utente trovato!');
          setUserInfo(null);
        }
      } else {
        setUser(null);
        navigate('/');
      }
      setIsAuthLoading(false); // Imposta isAuthLoading a false quando lo stato di autenticazione è determinato
    });

    return () => unsubscribe();
  }, [navigate]);

  if (isAuthLoading) {
    return (
        <div className="loading-overlay">
            <div className="loading-content">
                <Circles height="80" width="80" color="#ffffff" ariaLabel="loading" />
                <p>Loading... Syncing profile info</p>
            </div>
        </div>
    );
}

  return (
    <div className="tool-container">
      {user && userInfo && <Topbar userInfo={userInfo} user={user} />}
      <h2>Age Estimation in children by european formula</h2>
      <div className="bibliography-section" style={{ margin: '20px 0', padding: '15px', backgroundColor: '#f5f5f5', borderRadius: '5px', fontSize: '14px', lineHeight: '1.4' }}>
        <strong>Reference:</strong> Cameriere, R., Ferrante, L. & Cingolani, M. Age estimation in children by measurement of open apices in teeth. Int J Legal Med 120, 49–52 (2006).
      </div>
      {user ? (
        <ImageUpload user={user} userInfo={userInfo} />
      ) : (
        <div>Per favore, effettua il login per utilizzare questo strumento.</div>
      )}
    </div>
  );
};

export default ToolCanineTeeth;
